module.exports = __webpack_public_path__ + "static/user_view_no_customer-4301a794d5054b2e7c162b33ecd6fb24.png";